import React from "react";
import pkg from "../../../package.json";
const { version } = pkg;

type Props = {};

const About = (props: Props) => {
  return <div>v{version}</div>;
};

export default About;
